import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	HostBinding,
	Input,
	OnChanges,
	SimpleChange,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { AbstractControl, UntypedFormControl } from "@angular/forms";
import { coerceBoolean, PlatformService } from "@obg/ngx.global.evo";

import { SessionFrequency } from "./session-limit-item.const";

@Component({
	selector: "obg-m-session-limit-item",
	templateUrl: "./session-limit-item.component.html",
	styleUrls: ["./session-limit-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SessionLimitItemCommonComponent implements OnChanges {
	@HostBinding("class.obg-m-session-limit-item") hostCssClass = true;
	@HostBinding("class.obg-m-session-limit-item-registration") @Input() @coerceBoolean() hostRegistrationCssClass =
		false;

	@ViewChild("sessionInput")
	set input(value: ElementRef<HTMLInputElement> | undefined) {
		if (!value || !this.autoFocus || !this.platformService.isBrowser || !this.isInputInit) {
			return;
		}

		setTimeout(() => value.nativeElement.focus());
	}

	currentLimitText = "";
	iconName = "";
	inputSuffix = "";
	suggestionTestId = "";
	translationPrefix = "";

	@Input() control: UntypedFormControl | undefined;
	@Input() inputLabel: string | undefined;
	@Input() currentLimitValue: string | undefined;
	@Input() placeholder = "";
	@Input() set suffix(value: SessionFrequency | undefined) {
		if (!value) {
			return;
		}
		this.currentLimitText = `multi-session-limit.current-limit.${value}`;
		this.iconName = `ico-session-limit-${value}`;
		this.translationPrefix = `multi-session-limit.${value}`;
		this.inputSuffix = `multi-session-limit.${value}.input-suffix`;
		this.suggestionTestId = `session-limit-suggestion-${value}`;
	}
	@Input() @coerceBoolean() hideValidator = false;
	@Input() @coerceBoolean() hideIconAndSuffix = false;
	@Input() @coerceBoolean() autoFocus = false;
	@Input() @coerceBoolean() showInputField = false;
	@Input() limitSuggestion: string | undefined;
	@Input() @coerceBoolean() hideInputHint = false;

	private isInputInit = false;

	constructor(private platformService: PlatformService) {}

	ngOnChanges(changes: { showInputField: SimpleChange }) {
		this.isInputInit = changes?.showInputField?.currentValue && !changes.showInputField.previousValue;
	}

	get isSessionLimitItemRequired(): boolean {
		if (this.control?.validator) {
			const validator = this.control.validator({} as AbstractControl);
			if (validator?.required) {
				return true;
			}
		}
		return false;
	}
}
